module.exports = __webpack_public_path__ + "img/023.9d053620.png";